import React from 'react';
import { IconBase } from './IconBase';

export const IconLightning = (props) => (
    <IconBase viewBox="0 0 24 24" {...props}>
        <g id="Icon-/-Small-/-Lightning-/-Blue">
            <polygon id="Page-1" points="15 4 7.001 12 10.464 14 7 20 9 20 17 12 13.536 10 17 4" />
        </g>
    </IconBase>
);

IconLightning.defaultProps = {
    size: '24px',
    fill: '#05BDFF',
};

IconLightning.displayName = 'Lightning';

export default IconLightning;
